import React, { useEffect, useState } from 'react';
import API from '../api';
import DriverForm from './DriverForm';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';



function Drivers() {
  const [drivers, setDrivers] = useState([]);
  const [allDrivers, setAllDrivers] = useState([]);
  const [editing, setEditing] = useState(null);
  const [filterText, setFilterText] = useState('');
  const [filterAvailable, setFilterAvailable] = useState('');
  const [filterActive, setFilterActive] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };
  const fetchDrivers = async () => {
    try {
      const res = await API.get('drivers/');
      const list = Array.isArray(res.data) ? res.data : [];
      list.sort((a,b) => {
        const ta = a.created_at ? new Date(a.created_at).getTime() : (a.id || 0);
        const tb = b.created_at ? new Date(b.created_at).getTime() : (b.id || 0);
        return tb - ta;
      });
      setAllDrivers(list);
      setDrivers(list.slice(0,10));
    } catch (e) {
      setAllDrivers([]);
      setDrivers([]);
    }
  };

  const applyFilter = (text) => {
    const t = (text || '').toLowerCase();
    let filtered = allDrivers.filter(d => (`${d.name} ${d.phone} ${d.email || ''} ${d.driver_code || ''}`.toLowerCase().indexOf(t) !== -1));
    if (filterAvailable !== '') {
      filtered = filtered.filter(d => String(d.is_available) === filterAvailable);
    }
    if (filterActive !== '') {
      filtered = filtered.filter(d => String(d.is_active) === filterActive);
    }
    setDrivers(filtered.slice(0,10));
  }

  useEffect(() => { fetchDrivers(); }, []);
  useEffect(() => applyFilter(filterText), [filterText, allDrivers, filterAvailable, filterActive]);

  const handleDelete = (id) => API.delete(`drivers/${id}/`).then(fetchDrivers);
  const handleEdit = (driver) => setEditing(driver);
  const handleFormSubmit = () => { setEditing(null); fetchDrivers(); };

  return (

    <div className="page-container">

                <div className="login-buttons">
                    <button onClick={() => navigate('/')}>🏠 {t('Home')}</button>
                    <button onClick={handleLogout}>🚪 {t('Logout')}</button>
                </div>    
      <h2>{t('Drivers')}</h2>

      <DriverForm driver={editing} onSubmit={handleFormSubmit} />
      <div style={{display:'flex', gap:'10px', marginBottom:8}}>
        <select value={filterAvailable} onChange={e => setFilterAvailable(e.target.value)}  style={{borderRadius: '4px', padding: '8px'}}>
          <option value="">{t('Available')}</option>
          <option value="true">{t('Available')}</option>
          <option value="false">{t('Busy')}</option>
        </select>
        <select value={filterActive} onChange={e => setFilterActive(e.target.value)} style={{borderRadius: '4px', padding: '8px'}}>
          <option value="">{t('Active')}</option>
          <option value="true">{t('Active')}</option>
          <option value="false">{t('Inactive')}</option>
        </select>
        <input
          type="search"
          placeholder={t('Search...')}
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          style={{borderRadius: '4px', width: '100%', padding: '8px'}}
        />
      </div>
            <div style={{marginBottom:12}}>

        <div style={{fontSize:12, color:'#666'}}>{t('Showing latest')} {drivers.length} {t('drivers')}</div>
      </div>
      <ul>
        {drivers.map(d => (
          <li key={d.id}>
            {d.name} ({d.phone})
            <span style={{marginLeft:8}}>{d.is_available ? t('Available') : t('Busy')}</span>
            <span style={{marginLeft:8}}>{d.is_active ? t('Active') : t('Inactive')}</span>
            <button onClick={() => handleEdit(d)}>{t('Edit')}</button>
            <button onClick={() => handleDelete(d.id)}>{t('Delete')}</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Drivers;
